module.exports = __webpack_public_path__ + "static/media/logo_header_white.829e5b04.svg";